import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { StickyContainer, Sticky } from 'react-sticky';
import cx from 'classnames';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Googletag } from 'shared/modules';
import { ContentRollAdsense } from 'shared/modules/googletag/contentRollAdsense';
import LazyLoad from 'react-lazyload';
import s from './BannerAll.css';

const MARGIN_TOP = 63;
const MARGIN_BOTTOM = 100;

let distanceFromBottom = 0;

export const DesktopButtonMark = () => (
  <StickyContainer>
    <Sticky topOffset={-68} disableCompensation>
      {({ distanceFromBottom: distance }) => {
        distanceFromBottom = Number(distance);
        return <div />;
      }}
    </Sticky>
  </StickyContainer>
);

export const DesktopButton = withStyles(s)(() => (
  <StickyContainer>
    <Sticky topOffset={-68} disableCompensation>
      {({ distanceFromBottom: distance }) => {
        distanceFromBottom = Number(distance);
        return (
          <div className={s.advertContainerButoon} id="div-gpt-ad-desktop_button-all">
            <ContentRollAdsense />
          </div>
        );
      }}
    </Sticky>
  </StickyContainer>
)); /* data.children */

export const DesktopRightSidebar = withStyles(s)(data => {
  if (data.scrollNo) {
    return (
      <div className={cx(s.flexCell, s.sideBar)}>
        <div className={s.gptPremium}>
          <LazyLoad>
            <Googletag id="div-gpt-ad-1510239331518-1" />
          </LazyLoad>
        </div>
        {(data && data.children) || ''}
        <LazyLoad>
          <Googletag id="div-gpt-ad-1510224251147-0" />
        </LazyLoad>
      </div>
    );
  } else if (data.fixedSecondBanner) {
    return (
      <div className={cx(s.flexCell, s.sideBar)}>
        <div id="height-div-gpt-ad-1510239331518-1">
          <div className={s.gptPremium}>
            <LazyLoad>
              <Googletag id="div-gpt-ad-1510239331518-1" />
            </LazyLoad>
          </div>
          {(data && data.children) || ''}
        </div>

        <StickyContainer className={s.homeSideBar}>
          <Sticky topOffset={-MARGIN_TOP} disableCompensation>
            {props => {
              const { style, distanceFromBottom: bottomDistance } = props;
              let customStyle = { ...style, top: `${MARGIN_TOP}px` };

              if (+bottomDistance < MARGIN_BOTTOM) {
                customStyle = { ...style, top: bottomDistance - 20 };
              }
              return (
                <div style={customStyle}>
                  <div id="height-div-gpt-ad-1510224251147-0">
                    <LazyLoad>
                      <Googletag id="div-gpt-ad-1510224251147-0" />
                    </LazyLoad>
                  </div>
                </div>
              );
            }}
          </Sticky>
        </StickyContainer>
      </div>
    );
  }

  return (
    <StickyContainer>
      <Sticky topOffset={-MARGIN_TOP} disableCompensation>
        {({
          style = { transform: 'translateZ(0)' },
          distanceFromTop,
          distanceFromBottom: distanceFromBottomValue,
        }) => {
          const padding = 35;
          let scroll = MARGIN_TOP;
          let scrollTwo = 0;
          let bodyABIdBlockHeight = 0;
          let blockHeight = 0;
          let blockHeightAbove600 = false;
          let bodyABIdBlockHeightAbove = false;
          let doNotScroll = 0;

          let bannerBlock1 = 0;
          let bannerBlock2 = 0;

          if (process.env.BROWSER) {
            const heightDivDptAd1510239331518 =
              window.document.getElementById('height-div-gpt-ad-1510239331518-1') || {};
            const heightDivGptAd15102242511470 =
              window.document.getElementById('height-div-gpt-ad-1510224251147-0') || {};
            const bodyABIdBlock = window.document.getElementById('bodyABIdBlock') || {};
            bodyABIdBlockHeight = Number(bodyABIdBlock.clientHeight);
            blockHeight = Number(heightDivDptAd1510239331518.clientHeight);
            scroll = Number(`-${heightDivDptAd1510239331518.clientHeight}`) || MARGIN_TOP;
            scrollTwo = Number(`-${heightDivGptAd15102242511470.clientHeight}`) || 0;
            blockHeightAbove600 = blockHeight > 600;
            bodyABIdBlockHeightAbove =
              bodyABIdBlockHeight >
              Math.abs(distanceFromTop) + Math.abs(scrollTwo) + padding + 20 + 35;

            bannerBlock1 = Number(heightDivDptAd1510239331518.clientHeight) || 0;
            bannerBlock2 = Number(heightDivGptAd15102242511470.clientHeight) || 0;

            doNotScroll = bodyABIdBlockHeight - 130 < bannerBlock1 + bannerBlock2;
          }

          if (distanceFromBottomValue - padding - bannerBlock2 < 0) {
            scroll += distanceFromBottomValue - padding - bannerBlock2 + 35;
          } else if (!bodyABIdBlockHeightAbove) {
            scroll +=
              bodyABIdBlockHeight - Math.abs(distanceFromTop) - Math.abs(scrollTwo) - padding - 20;
          } else if (blockHeightAbove600) {
            if (distanceFromBottom + scrollTwo + padding < 100) {
              if (distanceFromBottom + scrollTwo - MARGIN_TOP > scroll) {
                scroll = distanceFromBottom + scrollTwo;
              } else {
                scroll += padding;
              }
            } else {
              scroll = MARGIN_TOP;
            }
          } else {
            scroll = distanceFromTop;
          }

          const fun = () => {
            const obj = {};
            if (!blockHeightAbove600 && distanceFromTop < Number(`-${blockHeight}`)) {
              obj.position = 'fixed';
              obj.top = `${Math.abs(distanceFromTop - MARGIN_TOP)}px`;
            }
            return obj;
          };

          return (
            <div className={cx(s.flexCell, s.sideBar)}>
              <div style={doNotScroll ? {} : { ...style, top: `${scroll}px` }}>
                <div id="height-div-gpt-ad-1510239331518-1">
                  <div className={s.gptPremium}>
                    <LazyLoad>
                      <Googletag id="div-gpt-ad-1510239331518-1" />
                    </LazyLoad>
                  </div>
                  {(data && data.children) || ''}
                </div>
                <div style={fun()} id="height-div-gpt-ad-1510224251147-0">
                  <LazyLoad>
                    <Googletag id="div-gpt-ad-1510224251147-0" />
                  </LazyLoad>
                </div>
              </div>
            </div>
          );
        }}
      </Sticky>
    </StickyContainer>
  );
});

export const BannersBuffer = connect(({ globals }) => ({
  bannerNotErr: globals.banner && globals.banner.bannerNotErr,
}))(
  class BannersBuffer extends React.Component {
    static propTypes = {
      bannerNotErr: PropTypes.shape(),
    };
    static defaultProps = {
      bannerNotErr: {},
    };

    render() {
      const { bannerNotErr } = this.props;
      return (
        <div style={{ display: 'none' }}>
          {Object.keys(bannerNotErr).map(a => (
            <div id={a} key={a}>
              {'.'}
            </div>
          ))}
        </div>
      );
    }
  },
);



// WEBPACK FOOTER //
// ./src/shared/components/BannerAll/index.js